export default (clienteProveedor = {}) => ({
  // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
  id: clienteProveedor.id,
  // @ts-expect-error TS(2339): Property 'estadoRevisionActual' does not exist on ...
  estadoRevisionActual: clienteProveedor.estadoRevisionActual,
  // @ts-expect-error TS(2339): Property 'fechaEmision' does not exist on type '{}...
  fechaEmision: clienteProveedor.fechaEmision,
  // @ts-expect-error TS(2339): Property 'importe' does not exist on type '{}'.
  importe: clienteProveedor.importe,
  // @ts-expect-error TS(2339): Property 'cliente' does not exist on type '{}'.
  nifLibrado: clienteProveedor.cliente.cif,
  // @ts-expect-error TS(2339): Property 'usuario' does not exist on type '{}'.
  nifLibrador: clienteProveedor.usuario.cif,
  // @ts-expect-error TS(2339): Property 'numero' does not exist on type '{}'.
  numero: clienteProveedor.numero,
  // @ts-expect-error TS(2339): Property 'cliente' does not exist on type '{}'.
  razonSocial: clienteProveedor.cliente.razonSocial,
  // @ts-expect-error TS(2339): Property 'cliente' does not exist on type '{}'.
  razonSocialLibrado: clienteProveedor.cliente.razonSocial,
  // @ts-expect-error TS(2339): Property 'usuario' does not exist on type '{}'.
  razonSocialLibrador: clienteProveedor.usuario.razonSocial,
  // @ts-expect-error TS(2339): Property 'serie' does not exist on type '{}'.
  serie: clienteProveedor.serie,
})
